/** @jsxImportSource react */
// Brand mark SVGs — paths sourced directly from the OnArk Brand Paper file (v2 · 06 — Logo).
// The dove is the 5 leading paths; the wordmark is the remaining 6.

const DOVE_PATHS = (
  <>
    <path d="M43.095 13.5C42.552 10.803 39.767 4.094 38.214 7.042C36.375 10.056 32.968 12.708 28.82 14.766C28.557 12.845 27.637 10.229 26.565 8.829C26.218 8.376 25.797 8.087 26.234 9.612C26.737 11.536 27.098 13.494 27.316 15.472C24.405 16.751 21.368 17.722 18.255 18.367C18.223 16.094 17.769 13.846 16.915 11.739C19.381 9.641 21.343 7.015 22.656 4.056C22.656 4.056 22.921 3.061 23.385 3.459C25.571 4.719 29.215 9.161 29.215 9.161C29.215 9.161 29.951 10.234 30.257 9.435C30.322 9.227 30.341 9.007 30.314 8.79C30.288 8.573 30.215 8.365 30.101 8.179C27.821 3.979 22.722 0.608 22.722 0.608C22.722 0.608 22.046 0.277 21.662 0.608C19.012 4.255 12.454 5.05 12.454 5.05C12.454 5.05 11.195 5.315 12.189 5.448C13.183 5.581 17.224 5.581 20.602 3.791C14.309 17.381 2.914 13.006 2.914 13.006C2.914 13.006 2.912 13.044 2.915 13.109C2.947 13.971 5.268 14.945 6.125 15.036C9.397 15.417 12.698 14.63 15.448 12.815C15.466 12.843 15.486 12.871 15.507 12.897C16.185 13.647 16.895 16.766 16.867 18.634C13.677 19.222 10.425 19.408 7.189 19.189C7.115 18.575 6.891 17.242 6.293 16.718C5.763 16.254 5.697 16.984 5.697 16.984C5.811 17.666 5.853 18.359 5.822 19.05C4.19 18.857 2.585 18.483 1.035 17.934C0.503 17.74 0.526 18.471 1.035 18.728C8.626 22.566 24.563 21.63 37.48 12.373C37.564 12.312 37.66 12.271 37.762 12.254C37.864 12.236 37.968 12.241 38.067 12.27C38.166 12.298 38.258 12.349 38.334 12.418C38.411 12.488 38.471 12.573 38.509 12.669C39.517 15.176 42.002 23.345 36.484 32.897C36.402 33.038 36.373 33.203 36.402 33.364C37.043 36.646 45.543 26.969 43.095 13.5Z" />
    <path d="M34.214 23.453C32.425 30.613 26.628 35.411 25.457 36.471C24.286 37.532 25.668 39.232 26.993 38.238C35.695 31.026 35.141 22.326 35.141 22.326C34.876 20.735 34.214 23.453 34.214 23.453Z" />
    <path d="M24.507 27.45C22.398 31.636 18.208 33.939 17.244 34.438C16.279 34.937 16.949 36.45 18.261 36.223C24.42 33.531 25.373 27.403 25.373 27.403C25.402 26.062 24.507 27.45 24.507 27.45Z" />
    <path d="M18.849 27.425C19.997 25.566 19.332 26.209 18.931 26.437C18.931 26.437 14.829 28.835 12.675 29.119C10.522 29.403 11.321 30.911 11.321 30.911C11.321 30.911 11.849 31.822 13.23 31.438C14.61 31.055 17.702 29.285 18.849 27.425Z" />
    <path d="M13.567 23.642C12.611 23.844 10.135 23.759 8.967 23.652C7.8 23.546 7.694 24.29 7.694 24.29C7.694 24.29 7.588 25.682 8.826 25.67C12.262 25.637 14.168 24.006 14.168 24.006C14.557 23.44 14.522 23.44 13.567 23.642Z" />
  </>
);

const WORDMARK_PATHS = (
  <>
    <path d="M108.312 28.472V22.784C108.383 21.492 108.865 20.261 109.684 19.285C111.509 17.247 114.07 17.531 114.44 17.559V20.66C113.876 20.599 113.305 20.671 112.771 20.868C112.115 21.111 111.376 21.897 111.376 22.883V28.472H108.312Z" />
    <path
      clipRule="evenodd"
      d="M65.64 29C69.628 29 72.861 25.55 72.861 21.295C72.861 17.04 69.628 13.591 65.64 13.591C61.651 13.591 58.418 17.04 58.418 21.295C58.418 25.55 61.651 29 65.64 29ZM65.638 25.374C67.75 25.374 69.461 23.547 69.461 21.295C69.461 19.042 67.75 17.216 65.638 17.216C63.527 17.216 61.815 19.042 61.815 21.295C61.815 23.547 63.527 25.374 65.638 25.374Z"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M85.554 28.472V22.089C85.554 19.572 83.497 17.53 80.959 17.53C78.421 17.53 76.363 19.572 76.363 22.089V28.472H79.58V26.44C79.58 26.44 79.581 26.44 79.581 26.44V22.089C79.581 21.334 80.198 20.721 80.959 20.721C81.721 20.721 82.338 21.334 82.338 22.089V28.472H82.338V28.472H85.554Z"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M103.062 28.701V19.887C103.062 16.41 100.22 13.591 96.715 13.591C93.21 13.591 90.369 16.41 90.369 19.887V28.701H93.871V19.255C93.871 18.06 95.145 17.092 96.716 17.092C98.287 17.092 99.561 18.06 99.561 19.255V28.701H103.062Z"
      fillRule="evenodd"
    />
    <path d="M127.728 28.413L125.072 23.936C126.069 22.565 127.999 20.403 127.999 18.042H124.371V18.551C124.371 20.11 123.02 21.326 121.469 21.161V13.153H118.379V28.413H121.469V25.532L122.552 25.185L124.375 28.413H127.728Z" />
    <rect height="2.626" width="5.69" x="93.869" y="21.469" />
  </>
);

interface LogoProps {
  className?: string;
  fill?: string;
}

export function OnArkLogo({
  className = 'h-[30px] w-auto sm:h-[37px]',
  fill = 'var(--color-amethyst)',
}: LogoProps) {
  return (
    <svg
      aria-label="OnArk"
      className={className}
      fill={fill}
      viewBox="0 0 128 39"
      xmlns="http://www.w3.org/2000/svg"
    >
      {DOVE_PATHS}
      {WORDMARK_PATHS}
    </svg>
  );
}

interface DoveProps {
  className?: string;
  style?: React.CSSProperties;
  fill?: string;
}

export function Dove({
  className,
  fill = 'var(--color-amethyst)',
  style,
}: DoveProps) {
  return (
    <svg
      aria-hidden
      className={className}
      fill={fill}
      style={style}
      viewBox="0 0 45 39"
      xmlns="http://www.w3.org/2000/svg"
    >
      {DOVE_PATHS}
    </svg>
  );
}
